import { forwardRef } from 'react';
import type { ButtonProps } from '@elfsight/widget-ui';
import { Button } from '@elfsight/widget-ui';
import { CTAButtonTypeStyles } from '../../common/cta-button-styles';
import type {
  CTAButton,
  CTAButtonType
} from '../../common/location-card-types';
import { useLocationCardProps } from '../location-card-settings-context';
import { customIsDark } from '../utils/custom-is-dark';

type CommonButtonProps = {
  ctaButton: CTAButton;
} & ButtonProps;

export const CommonButton = forwardRef<HTMLButtonElement, CommonButtonProps>(
  function CommonButton({ ctaButton, ...forwardingProps }, forwardingRef) {
    const {
      ctaButtonsStyle,
      ctaButtonsRadius,
      ctaButtonsSize,
      accentColor,
      platformCtaButtonColor
    } = useLocationCardProps();
    const { id, icon: derivedIcon, text, type } = ctaButton;

    const buttonStylesByType = CTAButtonTypeStyles[type as CTAButtonType];

    const buttonColor =
      platformCtaButtonColor === 'native'
        ? buttonStylesByType?.color || accentColor
        : accentColor;
    const fontColor = customIsDark(buttonColor);
    const buttonIcon = buttonStylesByType?.icon || derivedIcon;

    return (
      <Button
        ref={forwardingRef}
        key={id}
        iconLeft={buttonIcon}
        font={{
          fontWeight: 'bold',
          fontStyle: 'normal',
          fontSize:
            typeof ctaButtonsSize.value === 'string'
              ? ctaButtonsSize?.customValue
              : ctaButtonsSize?.value
        }}
        fontColor={fontColor}
        color={buttonColor}
        borderRadius={ctaButtonsRadius}
        mode={ctaButtonsStyle}
        {...forwardingProps}
      >
        {text}
      </Button>
    );
  }
);
